import { render, staticRenderFns } from "./Vendas.vue?vue&type=template&id=25e9ffcf&"
import script from "./Vendas.vue?vue&type=script&lang=js&"
export * from "./Vendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports